import { IconProps } from "../../utils/global-types/global-types";

const SearchIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-6 h-6"}
      {...rest}
    >
      <g clipPath="url(#clip0_2023_2224)">
        <path
          fill="currentColor"
          d="m15.553 14.752-3.332-3.466a5.63 5.63 0 0 0 1.326-3.634A5.66 5.66 0 0 0 7.894 2a5.66 5.66 0 0 0-5.652 5.652 5.66 5.66 0 0 0 5.652 5.653c1.17 0 2.285-.353 3.239-1.023l3.357 3.492a.734.734 0 0 0 1.042.02.74.74 0 0 0 .02-1.042M7.894 3.475a4.183 4.183 0 0 1 4.178 4.177 4.183 4.183 0 0 1-4.178 4.178 4.183 4.183 0 0 1-4.178-4.178 4.183 4.183 0 0 1 4.178-4.177"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_2023_2224">
          <path fill="#fff" d="M2 2h14v14H2z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default SearchIcon;
